import React, { useState } from 'react';
import { Search, Filter, Plus } from 'lucide-react';
import { EmployeeCard } from '../components/EmployeeCard';
import { EmptyState } from '../components/EmptyState';
interface EmployeesPageProps {
  onSelectEmployee: (id: string) => void;
}
export function EmployeesPage({
  onSelectEmployee
}: EmployeesPageProps) {
  const [filter, setFilter] = useState<'all' | 'active' | 'inactive' | 'missing'>('all');
  const [search, setSearch] = useState('');
  // Mock data
  const employees = [{
    id: 'EMP001',
    name: 'Sarah Connor',
    role: 'Manager',
    isActive: true,
    hasFingerprint: true,
    hasFace: true
  }, {
    id: 'EMP002',
    name: 'John Smith',
    role: 'Developer',
    isActive: true,
    hasFingerprint: true,
    hasFace: false
  }, {
    id: 'EMP003',
    name: 'Kyle Reese',
    role: 'Security',
    isActive: false,
    hasFingerprint: false,
    hasFace: false
  }, {
    id: 'EMP004',
    name: 'Marcus Wright',
    role: 'Intern',
    isActive: true,
    hasFingerprint: false,
    hasFace: true
  }, {
    id: 'EMP005',
    name: 'T-800',
    role: 'Logistics',
    isActive: true,
    hasFingerprint: true,
    hasFace: true
  }];
  const filteredEmployees = employees.filter(emp => {
    const matchesSearch = emp.name.toLowerCase().includes(search.toLowerCase()) || emp.id.toLowerCase().includes(search.toLowerCase());
    if (!matchesSearch) return false;
    if (filter === 'active') return emp.isActive;
    if (filter === 'inactive') return !emp.isActive;
    if (filter === 'missing') return !emp.hasFingerprint || !emp.hasFace;
    return true;
  });
  return <div className="p-4 pb-20 space-y-4" data-id="element-157">
      {/* Header */}
      <div className="flex justify-between items-center mb-2" data-id="element-158">
        <div data-id="element-159">
          <h1 className="text-2xl font-bold text-white" data-id="element-160">Employees</h1>
          <p className="text-slate-400 text-sm" data-id="element-161">
            {employees.length} Total •{' '}
            {employees.filter(e => e.isActive).length} Active
          </p>
        </div>
        <button className="bg-blue-600 p-2 rounded-full text-white shadow-lg hover:bg-blue-700 transition-colors" data-id="element-162">
          <Plus size={24} data-id="element-163" />
        </button>
      </div>

      {/* Search */}
      <div className="relative" data-id="element-164">
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" size={20} data-id="element-165" />
        <input type="text" placeholder="Search by name or ID..." value={search} onChange={e => setSearch(e.target.value)} className="w-full bg-slate-800 border border-slate-700 rounded-lg pl-10 pr-4 py-3 text-white placeholder-slate-500 focus:outline-none focus:border-blue-500 transition-colors" data-id="element-166" />
      </div>

      {/* Filters */}
      <div className="flex space-x-2 overflow-x-auto pb-2 scrollbar-hide" data-id="element-167">
        {[{
        id: 'all',
        label: 'All'
      }, {
        id: 'active',
        label: 'Active'
      }, {
        id: 'inactive',
        label: 'Inactive'
      }, {
        id: 'missing',
        label: 'Missing Biometrics'
      }].map(f => <button key={f.id} onClick={() => setFilter(f.id as any)} className={`px-4 py-1.5 rounded-full text-sm font-medium whitespace-nowrap transition-colors ${filter === f.id ? 'bg-blue-500 text-white' : 'bg-slate-800 text-slate-400 border border-slate-700'}`} data-id="element-168">
            {f.label}
          </button>)}
      </div>

      {/* List */}
      <div className="space-y-3" data-id="element-169">
        {filteredEmployees.length > 0 ? filteredEmployees.map(emp => <EmployeeCard key={emp.id} employee={emp} onClick={() => onSelectEmployee(emp.id)} data-id="element-170" />) : <EmptyState icon={<Filter size={32} data-id="element-172" />} title="No employees found" description="Try adjusting your search or filters to find what you're looking for." data-id="element-171" />}
      </div>
    </div>;
}